import React from "react";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
const ESClusterError = styled(Alert)`
  margin-top: 10px;
  margin-bottom: 5px;
`;
const IndexerClusterHealthError = ({
  error,
  name = void 0
}) => /* @__PURE__ */ React.createElement(ESClusterError, { bsStyle: "danger" }, "Could not retrieve ", (name == null ? void 0 : name.distribution) || "Elasticsearch", " cluster health. Fetching", " ", (name == null ? void 0 : name.distribution) || "Elasticsearch", " cluster health failed: ", error.message);
export default IndexerClusterHealthError;
